import { sendAnalytics } from '@audio-network/analytics'
import {
	Button,
	Modal,
	ModalActions,
	ModalContent,
	ModalHeading,
	Paragraph,
} from '@audio-network/componentlibrary'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'

import { clientDeleteCollaborator } from '@/client'
import sessionStore from '@/stores/sessionStore'

import { redirectToHref } from '../../../../utils/window'

type Props = {
	id: string
}

const leaveProjectModalHeadingId = 'leave-project-modal-heading'
const leaveProjectModalDescriptionId = 'leave-project-modal-description'

export default function LeaveProjectModal({ id }: Props): JSX.Element {
	const projectId = useRouter().query.id as string
	const user = sessionStore((state) => state.session?.user)

	const { t } = useTranslation(['projectedit'])

	const handleLeaveProject = (leave: boolean): void => {
		if (leave && user?.id) {
			clientDeleteCollaborator(projectId, user.id)
				.then(() => {
					sendAnalytics({
						noun: 'Leave Project',
						pastTenseVerb: 'Completed',
					})
					redirectToHref(`/project/all`)
				})
				.catch(() => {
					// Error already logged by client; user remains on project
				})
		}
	}

	return (
		<Modal
			aria-describedby={leaveProjectModalDescriptionId}
			aria-labelledby={leaveProjectModalHeadingId}
			id={id}
		>
			<ModalHeading id={leaveProjectModalHeadingId}>
				{t('leave-project-modal.heading')}
			</ModalHeading>

			<ModalContent>
				<Paragraph id={leaveProjectModalDescriptionId}>
					{t('leave-project-modal.text')}
				</Paragraph>
			</ModalContent>

			<ModalActions>
				<Button onClick={() => handleLeaveProject(true)}>
					{t('leave-project-modal.yes')}
				</Button>
				<Button
					command="close"
					commandFor={id}
					onClick={() => handleLeaveProject(false)}
					variant="secondary"
				>
					{t('leave-project-modal.no')}
				</Button>
			</ModalActions>
		</Modal>
	)
}
